import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

const Impact = () => {
  const { t } = useLang();
  return (
    <section
      id="impact"
      data-testid="impact-section"
      className="relative bg-[#F7F8FA] py-24 md:py-36 border-t border-[#E4E7ED]"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 md:mb-20">
          <div className="lg:col-span-8">
            <p className="text-[11px] tracking-[0.35em] uppercase text-[#6F2DBD] font-semibold mb-6 flex items-center gap-3">
              <span className="inline-block w-10 h-px bg-[#6F2DBD]" />
              {t.impact.overline}
            </p>
            <h2 className="font-display text-[#002B6B] text-4xl md:text-5xl lg:text-6xl leading-[1.02] uppercase">
              {t.impact.title}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#E4E7ED] border border-[#E4E7ED]">
          {t.impact.stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              data-testid={`impact-${i}`}
              className="bg-white px-6 py-10 md:py-14 flex flex-col justify-end min-h-[220px]"
            >
              <p className="font-display text-4xl md:text-5xl text-[#002B6B] leading-none tracking-tight">
                {s.value}
              </p>
              <p className="mt-5 text-[11px] tracking-wide uppercase text-[#6B7280] font-medium leading-snug">
                {s.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Impact;
